function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import Path from "./path.js";
import Polygon from "./polygon.js";
var Voronoi = /*#__PURE__*/ function() {
    "use strict";
    function Voronoi(delaunay) {
        var _ref = _sliced_to_array(arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
            0,
            0,
            960,
            500
        ], 4), xmin = _ref[0], ymin = _ref[1], xmax = _ref[2], ymax = _ref[3];
        _class_call_check(this, Voronoi);
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    _create_class(Voronoi, [
        {
            key: "update",
            value: function update() {
                this.delaunay.update();
                this._init();
                return this;
            }
        },
        {
            key: "_init",
            value: function _init() {
                var _this = this, _this_delaunay = _this.delaunay, points = _this_delaunay.points, hull = _this_delaunay.hull, triangles = _this_delaunay.triangles, vectors = _this.vectors;
                // Compute circumcenters.
                var circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
                for(var i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
                    var t1 = triangles[i] * 2;
                    var t2 = triangles[i + 1] * 2;
                    var t3 = triangles[i + 2] * 2;
                    var x1 = points[t1];
                    var y1 = points[t1 + 1];
                    var x2 = points[t2];
                    var y2 = points[t2 + 1];
                    var x3 = points[t3];
                    var y3 = points[t3 + 1];
                    var dx = x2 - x1;
                    var dy = y2 - y1;
                    var ex = x3 - x1;
                    var ey = y3 - y1;
                    var bl = dx * dx + dy * dy;
                    var cl = ex * ex + ey * ey;
                    var ab = (dx * ey - dy * ex) * 2;
                    if (!ab) {
                        // degenerate case (collinear diagram)
                        x = (x1 + x3) / 2 - 1e8 * ey;
                        y = (y1 + y3) / 2 + 1e8 * ex;
                    } else if (Math.abs(ab) < 1e-8) {
                        // almost equal points (degenerate triangle)
                        x = (x1 + x3) / 2;
                        y = (y1 + y3) / 2;
                    } else {
                        var d = 1 / ab;
                        x = x1 + (ey * bl - dy * cl) * d;
                        y = y1 + (dx * cl - ex * bl) * d;
                    }
                    circumcenters[j] = x;
                    circumcenters[j + 1] = y;
                }
                // Compute exterior cell rays.
                var h = hull[hull.length - 1];
                var p0, p1 = h * 4;
                var x0, x11 = points[2 * h];
                var y0, y11 = points[2 * h + 1];
                vectors.fill(0);
                for(var i1 = 0; i1 < hull.length; ++i1){
                    h = hull[i1];
                    p0 = p1, x0 = x11, y0 = y11;
                    p1 = h * 4, x11 = points[2 * h], y11 = points[2 * h + 1];
                    vectors[p0 + 2] = vectors[p1] = y0 - y11;
                    vectors[p0 + 3] = vectors[p1 + 1] = x11 - x0;
                }
            }
        },
        {
            key: "render",
            value: function render(context) {
                var buffer = context == null ? context = new Path : undefined;
                var _this = this, _this_delaunay = _this.delaunay, halfedges = _this_delaunay.halfedges, inedges = _this_delaunay.inedges, hull = _this_delaunay.hull, circumcenters = _this.circumcenters, vectors = _this.vectors;
                if (hull.length <= 1) return null;
                for(var i = 0, n = halfedges.length; i < n; ++i){
                    var j = halfedges[i];
                    if (j < i) continue;
                    var ti = Math.floor(i / 3) * 2;
                    var tj = Math.floor(j / 3) * 2;
                    var xi = circumcenters[ti];
                    var yi = circumcenters[ti + 1];
                    var xj = circumcenters[tj];
                    var yj = circumcenters[tj + 1];
                    this._renderSegment(xi, yi, xj, yj, context);
                }
                var h0, h1 = hull[hull.length - 1];
                for(var i1 = 0; i1 < hull.length; ++i1){
                    h0 = h1, h1 = hull[i1];
                    var t = Math.floor(inedges[h1] / 3) * 2;
                    var x = circumcenters[t];
                    var y = circumcenters[t + 1];
                    var v = h0 * 4;
                    var p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
                    if (p) this._renderSegment(x, y, p[0], p[1], context);
                }
                return buffer && buffer.value();
            }
        },
        {
            key: "renderBounds",
            value: function renderBounds(context) {
                var buffer = context == null ? context = new Path : undefined;
                context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
                return buffer && buffer.value();
            }
        },
        {
            key: "renderCell",
            value: function renderCell(i, context) {
                var buffer = context == null ? context = new Path : undefined;
                var points = this._clip(i);
                if (points === null || !points.length) return;
                context.moveTo(points[0], points[1]);
                var n = points.length;
                while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
                for(var _$i = 2; _$i < n; _$i += 2){
                    if (points[_$i] !== points[_$i - 2] || points[_$i + 1] !== points[_$i - 1]) context.lineTo(points[_$i], points[_$i + 1]);
                }
                context.closePath();
                return buffer && buffer.value();
            }
        },
        {
            key: "cellPolygons",
            value: function cellPolygons() {
                var _this, points, i, n, cell;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this, points = _this.delaunay.points;
                            i = 0, n = points.length / 2;
                            _state.label = 1;
                        case 1:
                            if (!(i < n)) return [
                                3,
                                4
                            ];
                            cell = this.cellPolygon(i);
                            if (!cell) return [
                                3,
                                3
                            ];
                            cell.index = i;
                            return [
                                4,
                                cell
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            ++i;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "cellPolygon",
            value: function cellPolygon(i) {
                var polygon = new Polygon;
                this.renderCell(i, polygon);
                return polygon.value();
            }
        },
        {
            key: "_renderSegment",
            value: function _renderSegment(x0, y0, x1, y1, context) {
                var S;
                var c0 = this._regioncode(x0, y0);
                var c1 = this._regioncode(x1, y1);
                if (c0 === 0 && c1 === 0) {
                    context.moveTo(x0, y0);
                    context.lineTo(x1, y1);
                } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
                    context.moveTo(S[0], S[1]);
                    context.lineTo(S[2], S[3]);
                }
            }
        },
        {
            key: "contains",
            value: function contains(i, x, y) {
                if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
                return this.delaunay._step(i, x, y) === i;
            }
        },
        {
            key: "neighbors",
            value: function neighbors(i) {
                var ci, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, j, cj, ai, li, aj, lj, err;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ci = this._clip(i);
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (!ci) return [
                                3,
                                12
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                10,
                                11,
                                12
                            ]);
                            _iterator = this.delaunay.neighbors(i)[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                9
                            ];
                            j = _step.value;
                            cj = this._clip(j);
                            if (!cj) return [
                                3,
                                8
                            ];
                            ai = 0, li = ci.length;
                            _state.label = 3;
                        case 3:
                            if (!(ai < li)) return [
                                3,
                                8
                            ];
                            aj = 0, lj = cj.length;
                            _state.label = 4;
                        case 4:
                            if (!(aj < lj)) return [
                                3,
                                7
                            ];
                            if (!(ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj])) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                j
                            ];
                        case 5:
                            _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 6:
                            aj += 2;
                            return [
                                3,
                                4
                            ];
                        case 7:
                            ai += 2;
                            return [
                                3,
                                3
                            ];
                        case 8:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 9:
                            return [
                                3,
                                12
                            ];
                        case 10:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                12
                            ];
                        case 11:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 12:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "_cell",
            value: function _cell(i) {
                var _this = this, circumcenters = _this.circumcenters, _this_delaunay = _this.delaunay, inedges = _this_delaunay.inedges, halfedges = _this_delaunay.halfedges, triangles = _this_delaunay.triangles;
                var e0 = inedges[i];
                if (e0 === -1) return null; // coincident point
                var points = [];
                var e = e0;
                do {
                    var t = Math.floor(e / 3);
                    points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
                    e = e % 3 === 2 ? e - 2 : e + 1;
                    if (triangles[e] !== i) break; // bad triangulation
                    e = halfedges[e];
                }while (e !== e0 && e !== -1);
                return points;
            }
        },
        {
            key: "_clip",
            value: function _clip(i) {
                // degenerate case (1 valid point: return the box)
                if (i === 0 && this.delaunay.hull.length === 1) {
                    return [
                        this.xmax,
                        this.ymin,
                        this.xmax,
                        this.ymax,
                        this.xmin,
                        this.ymax,
                        this.xmin,
                        this.ymin
                    ];
                }
                var points = this._cell(i);
                if (points === null) return null;
                var _this = this, V = _this.vectors;
                var v = i * 4;
                return V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points);
            }
        },
        {
            key: "_clipFinite",
            value: function _clipFinite(i, points) {
                var n = points.length;
                var P = null;
                var x0, y0, x1 = points[n - 2], y1 = points[n - 1];
                var c0, c1 = this._regioncode(x1, y1);
                var e0, e1;
                for(var j = 0; j < n; j += 2){
                    x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
                    c0 = c1, c1 = this._regioncode(x1, y1);
                    if (c0 === 0 && c1 === 0) {
                        e0 = e1, e1 = 0;
                        if (P) P.push(x1, y1);
                        else P = [
                            x1,
                            y1
                        ];
                    } else {
                        var S = void 0, sx0 = void 0, sy0 = void 0, sx1 = void 0, sy1 = void 0;
                        if (c0 === 0) {
                            if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                            var ref;
                            ref = _sliced_to_array(S, 4), sx0 = ref[0], sy0 = ref[1], sx1 = ref[2], sy1 = ref[3], ref;
                        } else {
                            if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                            var ref1;
                            ref1 = _sliced_to_array(S, 4), sx1 = ref1[0], sy1 = ref1[1], sx0 = ref1[2], sy0 = ref1[3], ref1;
                            e0 = e1, e1 = this._edgecode(sx0, sy0);
                            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                            if (P) P.push(sx0, sy0);
                            else P = [
                                sx0,
                                sy0
                            ];
                        }
                        e0 = e1, e1 = this._edgecode(sx1, sy1);
                        if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                        if (P) P.push(sx1, sy1);
                        else P = [
                            sx1,
                            sy1
                        ];
                    }
                }
                if (P) {
                    e0 = e1, e1 = this._edgecode(P[0], P[1]);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
                    return [
                        this.xmax,
                        this.ymin,
                        this.xmax,
                        this.ymax,
                        this.xmin,
                        this.ymax,
                        this.xmin,
                        this.ymin
                    ];
                }
                return P;
            }
        },
        {
            key: "_clipSegment",
            value: function _clipSegment(x0, y0, x1, y1, c0, c1) {
                while(true){
                    if (c0 === 0 && c1 === 0) return [
                        x0,
                        y0,
                        x1,
                        y1
                    ];
                    if (c0 & c1) return null;
                    var x = void 0, y = void 0, c = c0 || c1;
                    if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
                    else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
                    else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
                    else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
                    if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
                    else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
                }
            }
        },
        {
            key: "_clipInfinite",
            value: function _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
                var P = Array.from(points), p;
                if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
                if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
                if (P = this._clipFinite(i, P)) {
                    for(var j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
                        c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
                        if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
                    }
                } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
                    P = [
                        this.xmin,
                        this.ymin,
                        this.xmax,
                        this.ymin,
                        this.xmax,
                        this.ymax,
                        this.xmin,
                        this.ymax
                    ];
                }
                return P;
            }
        },
        {
            key: "_edge",
            value: function _edge(i, e0, e1, P, j) {
                while(e0 !== e1){
                    var x = void 0, y = void 0;
                    switch(e0){
                        case 5:
                            e0 = 4;
                            continue; // top-left
                        case 4:
                            e0 = 6, x = this.xmax, y = this.ymin;
                            break; // top
                        case 6:
                            e0 = 2;
                            continue; // top-right
                        case 2:
                            e0 = 10, x = this.xmax, y = this.ymax;
                            break; // right
                        case 10:
                            e0 = 8;
                            continue; // bottom-right
                        case 8:
                            e0 = 9, x = this.xmin, y = this.ymax;
                            break; // bottom
                        case 9:
                            e0 = 1;
                            continue; // bottom-left
                        case 1:
                            e0 = 5, x = this.xmin, y = this.ymin;
                            break; // left
                    }
                    if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) {
                        P.splice(j, 0, x, y), j += 2;
                    }
                }
                if (P.length > 4) {
                    for(var _$i = 0; _$i < P.length; _$i += 2){
                        var _$j = (_$i + 2) % P.length, k = (_$i + 4) % P.length;
                        if (P[_$i] === P[_$j] && P[_$j] === P[k] || P[_$i + 1] === P[_$j + 1] && P[_$j + 1] === P[k + 1]) P.splice(_$j, 2), _$i -= 2;
                    }
                }
                return j;
            }
        },
        {
            key: "_project",
            value: function _project(x0, y0, vx, vy) {
                var t = Infinity, c, x, y;
                if (vy < 0) {
                    if (y0 <= this.ymin) return null;
                    if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
                } else if (vy > 0) {
                    if (y0 >= this.ymax) return null;
                    if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
                }
                if (vx > 0) {
                    if (x0 >= this.xmax) return null;
                    if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
                } else if (vx < 0) {
                    if (x0 <= this.xmin) return null;
                    if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
                }
                return [
                    x,
                    y
                ];
            }
        },
        {
            key: "_edgecode",
            value: function _edgecode(x, y) {
                return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
            }
        },
        {
            key: "_regioncode",
            value: function _regioncode(x, y) {
                return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
            }
        }
    ]);
    return Voronoi;
}();
export { Voronoi as default };
